import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Signin from 'src/app/login/views/Signin';

import TermsOfUseDeclined from './views/terms-of-use/TermsOfUseDeclined';
import ImpersonateUser from './views/impersonate-user/ImpersonateUser';

// Lazy load the terms of use component
const TermsOfUseComponent = lazy(() => import('./views/terms-of-use/TermsOfUse'));

const Login = () => {
    return (
        <Routes>
            <Route
                path={'/terms-of-use'}
                element={
                    <Suspense fallback='Loading...'>
                        <TermsOfUseComponent />
                    </Suspense>
                }
            />
            <Route path={'/terms-of-use-declined'} element={<TermsOfUseDeclined />} />
            <Route path={'/impersonate-user'} element={<ImpersonateUser />} />
            <Route path={'/'} element={<Signin />} />
        </Routes>
    );
};
export default Login;
